import TableOfConentsBoxEditing from "./tableOfContentsBoxEditing"
import TableOfContentsBoxUi from "./tableOfContentsBoxUi"
import Plugin from "@ckeditor/ckeditor5-core/src/plugin"

export default class TableOfContentsBox extends Plugin {
  static get requires() {
    return [TableOfConentsBoxEditing, TableOfContentsBoxUi]
  }
}
